import React from 'react';
import { humanCalculators_Fr } from '../ConstantsFr';
import SharedHelmet from '.././Helmet';

const TITLE = 'Calculatrices d age, dates et temps en ligne';
const DESCRIPTION = 'Calculez votre age exact, la difference entre deux dates, un compte a rebours anniversaire ou des durees precises avec nos calculatrices de temps en francais.';
const KEYWORDS = 'calculatrice age, difference de dates, calculatrice date, compte a rebours anniversaire, calculatrice temps, calendrier gregorien';
const OG_URL = 'https://do-calculate.com/fr/human-calculators/';

function HumanCalculatorsList() {
    return (
        <div className="container ltr-container">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
            <div>
                <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                <hr />
                <div className="alert alert-info" role="alert">
                    <p>Cette section rassemble les meilleurs outils pour vos calculs de dates, de durees et d evenements personnels.</p>
                </div>
            </div>
            <hr />
            <table>
                <thead>
                    <tr>
                        <th>Calculatrice</th>
                        <th>Description</th>
                    </tr>
                </thead>
                <tbody>
                    {humanCalculators_Fr.map((calculator, index) => (
                        <tr key={index}>
                            <td>
                                <a href={calculator.link}> <h2 style={{ fontSize: '14px' }}>{calculator.name}</h2> </a>
                            </td>
                            <td><p>{calculator.description}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br />
        </div>
    );
}

export default HumanCalculatorsList;
